import { DirectionKind } from '../../enums/enums';

const directionKindToReadable = {
  [DirectionKind.JS]: 'JS',
  [DirectionKind.QA]: 'QA',
} as const;

export { directionKindToReadable };
